import { render } from "./index.vue?vue&type=template&id=3d22fc06&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=3d22fc06&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d22fc06"]])

export default __exports__